import { NgModule } from '@angular/core';


import { ClienteInternetSharedModule } from './cliente-internet-shared.module';
import { ClienteInternetRoutingModule } from './cliente-internet-routing.module';
import { ClienteTypeaheadSharedModule } from '../typeahead';
import { RepresentanteSharedModule } from '../../representante';
import { CidadeModule } from '../../../cidade';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';

import { ClienteInternetComponent } from './cliente-internet.component';
import { ClienteInternetFilterCollapseComponent } from './filter';


@NgModule({
    imports: [
        ClienteInternetSharedModule,
        ClienteInternetRoutingModule,
        ClienteTypeaheadSharedModule,
        RepresentanteSharedModule,
        CidadeModule,
        MultiselectDropdownModule
    ],
    declarations: [
        ClienteInternetComponent,
        ClienteInternetFilterCollapseComponent
    ]
})
export class ClienteInternetModule { }
